import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { AuCmmsStatusLabelModule } from '@app/shared/ui-components';

@Component({
	selector: 'cmms-entity-status',
	templateUrl: './cmms-entity-status.component.html',
	styleUrls: ['./cmms-entity-status.component.scss'],
	imports: [AuCmmsStatusLabelModule, MatMenuModule],
})
export class CmmsEntityStatusComponent {
	@Input() status: string;
	@Input() statuses: string[] = [];
	@Output() updateStatus = new EventEmitter<Partial<{ status: string }>>();

	@ViewChild('statusMenuTrigger') statusMenuTrigger: MatMenuTrigger;

	selectStatus(status: string) {
		this.updateStatus.emit({ status });
		this.statusMenuTrigger.closeMenu();
	}
}
